import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useLoadingActions } from "../../context/LoadingContext";

const ModalLoader = ({ loaderHomeScreen }) => {
  const { increment, decrement } = useLoadingActions();

  useEffect(() => {
    increment(loaderHomeScreen);
    return () => {
      decrement(loaderHomeScreen);
    };
    // loaderHomeScreen is expected to be stable; intentionally omitted from deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

ModalLoader.propTypes = {
  loaderHomeScreen: PropTypes.bool,
};

export default ModalLoader;
